//import { CRUDBasicListComponent_Template, CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component'; // HTML Template Plugins
import { /*CRUDBasicListComponent_Template,*/ CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component'; // HTML Template Plugins
import { /*CRUDBasicListComponent_Template,*/ CRUDBasicListForChildComponent } from '../crud-basic-list-for-child/crud-basic-list-for-child.component'; // HTML Template Plugins
//import { BenutzerListComponent_Template } from './benutzer-list.component.include_template'; // HTML Template Plugins

import { Component, OnInit, Inject, forwardRef, Injector, Input } from '@angular/core';
import { AppComponent } from '../app.component';

import { ILeistungRueckgemeldet } from '../_interfaces/leistung-rueckgemeldet';
import { ILeistungskatalogSpediteur } from '../_interfaces/leistungskatalog-spediteur';

import { DatumOhneZeitPipe } from '../_pipes/datum-ohne-zeit.pipe';
import { LeistungRueckgemeldetService } from '../_services/leistung-rueckgemeldet.service';
import { IBenutzer } from '../_interfaces/benutzer';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auftrags-checkliste-leistungen-list',
  //templateUrl: '../crud-basic-list/crud-basic-list.component.html',
  templateUrl: './auftrags-checkliste-leistungen-list.component.html',
  //template: `${CRUDBasicListComponent_Template || ''}${_Template}`,  // HTML Template Plugins
  styleUrls: ['../crud-basic-list/crud-basic-list.component.css'],
  host: {
    '(window:keydown)': 'hotkeys($event)',
    '(window:resize)': 'sizeTable()'
  }
})
export class AuftragsChecklisteLeistungenListComponent extends CRUDBasicListForChildComponent implements OnInit {
  @Input() leistungsKatalog: ILeistungskatalogSpediteur[];
  @Input() pruefdatum: Date;

  pageTitle: string = this.translate.instant("Zusatzleistungen", true);
  CRUDItemKurzform: string = "LeistungenRueckgemeldet";
  CRUDItemButtonTitleNeu: string = this.translate.instant("Neue Zusatzleistung", true);
  CRUDItemBezeichnungSingularCapitalized: string = "LeistungRueckgemeldet";
  CRUDItemBezeichnungPluralCapitalized: string = "LeistungenRueckgemeldet";
  CRUDItemBezeichnungSingular: string = "leistungRueckgemeldet";
  CRUDItemBezeichnungPlural: string = "leistungenRueckgemeldet";
  CRUDItemRouteSingular: string = "leistung-rueckgemeldet";
  CRUDItemRoutePlural: string = "leistungen-rueckgemeldet";
  CRUDItemHelpTopic: string = "Leistungen Rückgemeldet";

  CRUDItemParentName : string = "kopfdaten"; // wie heisst die Navigation zum Parent innerhalb des CRUDItem ? // AM Parent-ChildTab-CRUD
  CRUDItemChildName : string = "leistungenRueckgemeldet"; // wie heisst (das Array) der Childs innerhalb dem Parent ? // AM Parent-ChildTab-CRUD

  // Table Caption ausblenden
  //CRUDTemplatePluginTableCaption = document.createElement("null");
  //CRUDTemplatePluginTableHeader = document.createElement("null");

  debugMode: boolean = false;

  // customPipe !!!
  datumOhneZeitPipe: DatumOhneZeitPipe = new DatumOhneZeitPipe();

  benutzer: IBenutzer = null;
  benutzerSubscription: Subscription = null;
    
  CRUDItemAvailableCols: any[] = [
          {
            field: 'createdBy',
            header: this.translate.instant('CreatedBy', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 10,
            showByDefault: false
          },
          {
            field: 'created',
            header: this.translate.instant('Created', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 20,
            showByDefault: false
          },
          {
            field: 'modifiedBy',
            header: this.translate.instant('ModifiedBy', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 30,
            showByDefault: false
          },
          {
            field: 'modified',
            header: this.translate.instant('Modified', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 40,
            showByDefault: false
          },
          {
            field: 'auftragsdatenId',
            header: this.translate.instant('Auftragsdaten Id', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 50,
            showByDefault: false
          },
          {
            field: 'positionsNr',
            header: this.translate.instant('Positions-Nr.', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 60,
            showByDefault: true
          },
          {
            field: 'artikelnummer.artikelbezeichnung',
            header: this.translate.instant('Zusatzleistung', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 70,
            showByDefault: true
          },
          {
            field: 'menge',
            header: this.translate.instant('Menge', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 80,
            showByDefault: true,
          },
          {
            field: 'preis',
            header: this.translate.instant('Preis', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 100,
            showByDefault: true
          },
          {
            field: 'lieferdatum',
            header: this.translate.instant('Lieferdatum', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 120,
            showByDefault: true,
            customPipe: { 
              pipe: this.datumOhneZeitPipe, 
              args: ['/noUTC']
            }
          },
    ];

    constructor(
      @Inject(forwardRef(() => AppComponent)) public _app: AppComponent,
      private _crudItemService: LeistungRueckgemeldetService,
      private _injector: Injector
    ) {
      super(_app, _injector);
      this.crudItemService = _crudItemService;
    }

    ngOnInit() { 
      this.benutzerSubscription = this.app.benutzerBehaviourSubject.subscribe(benutzer => {
        if(benutzer != null) {
          console.log("AuftragsChecklisteLeistungenListComponent() got benutzer:", benutzer);
          this.benutzer = benutzer;

          // wenn keine Berechtigung für Preise -> ausblenden
          if(this.benutzer.zusatzleistungPreise != true) {
            const colPreis = this.CRUDItemAvailableCols.find( f => f.field == 'preis');
            colPreis.showByDefault = false;
          }
        }
      });

      super.ngOnInit();
    }

    addCRUDItem() {  // Overwrite ...
      super.addCRUDItem();

      // nächste PositionsNr. vergeben:
      let naechstePosNr = 1;
      if(this.crudItems != null) {
        naechstePosNr = this.crudItems[this.crudItems.length -1].positionsNr +1;
      }
      this.selectedCrudItem.positionsNr = naechstePosNr;

      // Menge und Preis = null -> soll er explizit eingeben!
      this.selectedCrudItem.menge = null;
      this.selectedCrudItem.preis = null;

      // Lieferdatum = "Prüfdatum"
      this.selectedCrudItem.lieferdatum = this.parentCrudItem.pruefdatum;

      // KopfdatenId
      this.selectedCrudItem.kopfdatenId = this.parentCrudItem.id;
    }

    deleteCRUDItem(CRUDItem: /*ITitel*/any) { // Overwrite ...
      /*if(CRUDItem.auftragspositionenId == null || CRUDItem.auftragspositionenId == 0) {
        super.deleteCRUDItem(CRUDItem);
      }
      else {*/
        this.confirmationService.confirm({
          message: this.translate.instant('Wollen Sie die Menge auf 0 setzen?', true) + '?',
          header: this.translate.instant('Löschen', true) + '?',
          icon: 'fa fa-trash',
          key: 'CRUDBasicListConfirmDialog_' + this.CRUDItemBezeichnungPluralCapitalized,
          accept: () => {
            this.loading = true;
            this.selectedCrudItem.menge = 0;
            this.messageWrapperService.postTimedMessage({ severity: 'success', summary: this.translate.instant("Menge wurde auf 0 gesetzt", true), detail: CRUDItem.artikelnummer.artikelbezeichnung })
          },
          reject: () => {
          }
        });
      //}
    }

    debug(obj) {
      console.log(".debug() crudItems:", this.crudItems);
      //this.selectedCrudItem = null;
    }
  
}
